<div class="table-responsive">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex align-items-center justify-content-between mt-3 mb-3" style="padding-left: 1%;">
            <h2 style="margin-bottom: 0;">Vendors</h2>
            <div class="button-items d-flex align-items-center" style="gap: 8px;">
              <button class="btn btn-primary btn-sm" (click)="loadVendorAccounts(lastTableLazyLoadEvent)"
                pTooltip="Refresh vendor list" appActionTooltip><i class="mdi mdi-reload"></i></button>
                <button class="btn btn-primary btn-sm" (click)="dt.clear()" pTooltip="Clear all column filters and sorting" appActionTooltip>Clear <i
                class="mdi mdi-filter-remove"></i></button>
              </div>
            </div>
          </div>
        </div>
        <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadVendorAccounts($event)"
          [value]="vendorAccounts" dataKey="id" styleClass="p-datatable-tasks" [rowHover]="true" [rows]="10"
          [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
          responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
          paginatorDropdownAppendTo="body" scrollable="true" scrollHeight="600px"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th>View</th>
              @for (col of columns; track col) {
                <th  [pSortableColumn]="col.isSortable ? col.field : null">
                  <div class="flex align-items-center">
                    {{ col.header }}
                    @if (col.isSortable) {
                      <p-sortIcon [field]="col.field"></p-sortIcon>
                    }
                    @if (col.isFilterable) {
                      <p-columnFilter matchMode="contains"   [showOperator]="false" [showAddButton]="false"
                        [matchModeOptions]="matchModeOptions" [type]="col.filterType || 'text'" [field]="col.field"
                      display="menu" ></p-columnFilter>
                    }
                  </div>
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-account let-columns="columns">
            <tr>
              <td>
                <div class="flex gap-2">
                  <button class="btn btn-info btn-sm" pTooltip="View vendor details" appActionTooltip (click)="viewVendor(account)" role="button"><i class="mdi mdi-eye"></i></button>
                  <!-- <button class="btn btn-warning btn-sm" title="Edit Vendor" (click)="editVendor(account)" role="button"><i class="mdi mdi-pencil"></i></button> -->
                </div>
              </td>
              @for (col of columns; track col) {
                <td  >
                  {{ account[col.field] }}
                </td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="cols.length + 1" class="text-center py-4">
                No vendors found.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="vendorDialog" (onHide)="closeDialog()" [style]="{width: '60%'}" [header]="title" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
      <form [formGroup]="vendorForm">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">Vendor Name</label>
                  <input class="form-control" type="text" formControlName="name" [disabled]="viewOnly" appSpellCheck>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">Address 1</label>
                  <input class="form-control" type="text" formControlName="address1" [disabled]="viewOnly" appSpellCheck>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">Address 2</label>
                  <input class="form-control" type="text" formControlName="address2" [disabled]="viewOnly" appSpellCheck>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">Address 3</label>
                  <input class="form-control" type="text" formControlName="address3" [disabled]="viewOnly" appSpellCheck>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">Address 4</label>
                  <input class="form-control" type="text" formControlName="address4" [disabled]="viewOnly" appSpellCheck>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">Address 5</label>
                  <input class="form-control" type="text" formControlName="address5" [disabled]="viewOnly" appSpellCheck>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">Phone</label>
                  <input class="form-control" type="text" formControlName="phone" [disabled]="viewOnly">
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">Email</label>
                  <input class="form-control" type="text" formControlName="email" [disabled]="viewOnly">
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">Status</label>
                  <input class="form-control" type="text" formControlName="isActive" [disabled]="viewOnly">
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">QB Date Created</label>
                  <input class="form-control" type="text" formControlName="qbDateCreated" disabled>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">QB Vendor ID</label>
                  <input class="form-control" type="text" formControlName="qbVendorId" disabled>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="mb-3">
                  <label class="form-label">ID</label>
                  <input class="form-control" type="text" formControlName="id" disabled>
                </div>
              </div>
            </div>
          </div>
        </div>
        @if (!viewOnly) {
          <div class="row">
            <div class="col-xl-12">
              <div class="button-items" style="float: right;">
                <a class="btn btn-primary" (click)="saveVendor()" pTooltip="Save changes to this vendor" appActionTooltip> Update </a>
                <a class="btn btn-secondary" (click)="closeDialog()" pTooltip="Discard changes and close" appActionTooltip> Cancel </a>
              </div>
            </div>
          </div>
        }
      </form>
    </ng-template>
  </p-dialog>
